import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import SearchIcon from '@material-ui/icons/Search';
import Typography from '@material-ui/core/Typography';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';

import api from '../api/backend'

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    addCourse: {
        marginBottom: 20
    },
    icon: {
        marginRight: theme.spacing.unit * 2,
    },
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class CourseManager extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { courses: [] }
    }

    componentDidMount() {
        api.getCourses().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ courses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }
    render() {
        const { classes } = this.props;
        const { courses } = this.state;
        return (
            <main>
                {/* Hero unit */}
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            คอร์สทั้งหมด
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <Link to="/newCourse" style={{ textDecoration: 'none', color: 'black' }}><Button variant="contained" size="large" color="primary" fullWidth className={classes.addCourse}>เพิ่มคอร์ส</Button></Link>
                        </Grid>
                    </Grid>
                    {/* End hero unit */}
                    <Grid container spacing={40}>
                        {courses.map(course => (
                            <Grid item key={course.id} sm={6} md={4} lg={4}>
                                <Link to={`/editCourse/${course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                    <Card className={classes.card}>
                                        <CardHeader
                                            avatar={
                                                <Avatar aria-label="Recipe" className={classes.avatar} src="https://cdn1.iconfinder.com/data/icons/technology-devices-2/100/Profile-512.png" />
                                            }
                                            title={course.title}
                                            subheader={moment(course.created).format('DD/MM/YYYY')}
                                        />
                                        <CardMedia
                                            className={classes.cardMedia}
                                            image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.id}`}
                                            title="Image title"
                                        />
                                        <CardContent className={classes.cardContent}>
                                            <Typography style={{ whiteSpace: 'pre-line', height: 65, overflow: 'hidden' }}>
                                                {course.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </main>
        );
    }
}

export default withStyles(styles)(CourseManager);